module.exports = __webpack_public_path__ + "img/dp-logo-white.0624acbe.png";